import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", discord: "", company: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(form);
      navigate("/portal");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] pt-32 pb-24 px-5 flex items-start justify-center" data-testid="register-page">
      <Seo title="Create Account" path="/register" />
      <div className="w-full max-w-md border border-white/10 bg-ink-surface p-8 sm:p-10">
        <img src="/arsenal-artists-logo.png" alt="Arsenal Artists emblem" className="h-14 w-14 object-contain" />
        <h1 className="mt-5 font-display text-2xl font-black tracking-tight">Create your account</h1>
        <p className="mt-1 text-sm text-slate-500">One account for briefs, projects, files and subscriptions.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          {error && <p className="border border-arsenal/50 bg-arsenal/10 px-4 py-3 text-sm text-arsenal-bright" data-testid="register-error">{error}</p>}
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Name *</span>
            <input required data-testid="register-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="aa-input" autoComplete="name" />
          </label>
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Email *</span>
            <input required type="email" data-testid="register-email" value={form.email} onChange={(e) => set("email", e.target.value)} className="aa-input" autoComplete="email" />
          </label>
          <label className="block">
            <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Password * (min 8 characters)</span>
            <input required type="password" minLength={8} data-testid="register-password" value={form.password} onChange={(e) => set("password", e.target.value)} className="aa-input" autoComplete="new-password" />
          </label>
          <div className="grid grid-cols-2 gap-4">
            <label className="block">
              <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Discord</span>
              <input data-testid="register-discord" value={form.discord} onChange={(e) => set("discord", e.target.value)} className="aa-input" />
            </label>
            <label className="block">
              <span className="mb-1.5 block font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">Company</span>
              <input data-testid="register-company" value={form.company} onChange={(e) => set("company", e.target.value)} className="aa-input" />
            </label>
          </div>
          <button type="submit" disabled={busy} data-testid="register-submit" className="clip-btn w-full bg-arsenal hover:bg-arsenal-bright disabled:opacity-50 text-white font-display font-bold tracking-widest text-sm py-3.5 transition-colors">
            {busy ? "CREATING…" : "CREATE ACCOUNT"}
          </button>
        </form>
        <p className="mt-6 text-sm text-slate-500">
          Already have an account?{" "}
          <Link to="/login" data-testid="register-login-link" className="text-arsenal hover:text-arsenal-bright">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
